/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Section_ExclusionsInputs */

const en_us2_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises you don't want`)
};

const pt_br2_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios que você não quer`)
};

const es_419_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios que no quieres`)
};

const pt_pt2_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios que não queres`)
};

const fr_fr2_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices dont tu ne veux pas`)
};

const de_de2_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen, die du nicht willst`)
};

const it_it2_profile_section_exclusions = /** @type {(inputs: Profile_Section_ExclusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi che non vuoi`)
};

/**
* | output |
* | --- |
* | "Exercises you don't want" |
*
* @param {Profile_Section_ExclusionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_section_exclusions = /** @type {((inputs?: Profile_Section_ExclusionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Section_ExclusionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_section_exclusions(inputs)
	if (locale === "es-419") return es_419_profile_section_exclusions(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_section_exclusions(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_section_exclusions(inputs)
	if (locale === "de-DE") return de_de2_profile_section_exclusions(inputs)
	if (locale === "it-IT") return it_it2_profile_section_exclusions(inputs)
	return en_us2_profile_section_exclusions(inputs)
});
export { profile_section_exclusions as "profile.section_exclusions" }